// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fca24f36","885":"1915b219","921":"9b588eaf"}[chunkId] + ".chunk.js";
};